export class UpdatePatientProcedureNotesCommand {
    patientProcedureDayId: string;
    text: string;
    date:Date;
    memberEmail:string;
}